import { Component, Vue } from 'vue-property-decorator'
import { getCustomerListById, getCustomerListByIdExportData, setFinanceOrderFinishByFinanceOrderId } from '@/api/projectList'
import { menuBtn } from '@/utils/menu_level2_button'
import { delNullProperty } from "@/utils/index";
import {File} from "@/views/customer/customer-transfrom/edit-customer-info/interface";
import moment from "moment"
import CommonData from "@/utils/commonData";
// import {makeUploadSignature} from "@/utils/uploadMd5";

@Component({
    // filters: {
    //     typeFilter: (val: number) => {
    //         return projectTypeList.filter(item => item.value === val)[0].key
    //     }
    // }
})
export default class AllProjectStudent extends Vue {
    tableHeadFilter = {
        gradeList: [],
        customerName: '',
        prevMarketCooperationName: '',
        dissertationType: '',
    }
    gradeOptions = CommonData.gradeList
    loading = false
    tableData = []
    // tableKey = Math.random()
    // tableRandom = Math.random()
    total = 0
    projectId: number = undefined
    exportButtonDisabled = false
    exportHeaderDialogVisible = false
    tableHeader = [
        { id: 1, filds: 'customerName', cnFilds: '姓名', isShow: true },
        { id: 2, filds: 'gender', cnFilds: '性别', isShow: true },
        { id: 3, filds: 'eduCode', cnFilds: '客户识别号', isShow: true },
        { id: 4, filds: 'prevMarketCooperationName', cnFilds: '上级合作伙伴', isShow: true },
        { id: 5, filds: 'directorUserRealName', cnFilds: '订单负责人', isShow: true },
        { id: 6, filds: 'attendSchool', cnFilds: '学校', isShow: true },
        { id: 7, filds: 'grade', cnFilds: '年级', isShow: true },
        { id: 8, filds: 'specialized', cnFilds: '专业', isShow: true },
        { id: 9, filds: 'dissertationType', cnFilds: '论文服务', isShow: true },
        { id: 10, filds: 'haveIPQ', cnFilds: 'IEPQ服务', isShow: true },
        { id: 11, filds: 'ipqSubject', cnFilds: 'IEPQ学科方向', isShow: true },
        { id: 12, filds: 'isCredit', cnFilds: 'Laser证书', isShow: true },
        { id: 13, filds: 'caseStatus', cnFilds: '转案状态', isShow: true },
        { id: 14, filds: 'financeBackMoneyStatus', cnFilds: '回款状态', isShow: true },
        { id: 15, filds: 'customerRemark', cnFilds: '客户备注', isShow: true },
        { id: 16, filds: 'remark', cnFilds: '订单备注', isShow: true },
        { id: 17, filds: 'createdAt', cnFilds: '创建时间', isShow: true },
        { id: 18, filds: 'parentPhone', cnFilds: '家长电话', isShow: true },
        { id: 19, filds: 'email', cnFilds: '邮箱', isShow: true },
        { id: 20, filds: 'weChat', cnFilds: '微信', isShow: true },
        { id: 21, filds: 'phone', cnFilds: '手机号', isShow: true },
        { id: 22, filds: 'finishAt', cnFilds: '服务完成时间', isShow: true },
        { id: 23, filds: 'haveApply', cnFilds: '网申资格', isShow: true },
        { id: 24, filds: 'registeredCourse', cnFilds: '报名的科研课题', isShow: true },
    ]
    isshowParentPhone = true
    isshowPhone = true
    isshowWeChat = true
    isshowEmail = true
    isshowPrevMarketCooperationName = true
    isshowEduCode = true
    dissertationTypeOptions = [
        '无',
        '国外独立一作',
        '国外共同一作',
        '中文独立一作',
        'CNKI英文独立一作'
    ]
    serviceDialog = false
    fileList = []
    financeOrderIdList: any = []
    previewPath = ''
    previewName = ''
    previewVisible = false
    timer = null
    createdAt=''
    // isReadonly = false
    page = 1
    pageSize = 20
    serviceCompleteId= ''
    signature = ''

    buttonShow = menuBtn

    // get baseUrl() {
    //     let str = '/fileApi/upload/upload'
    //     if (process.env.NODE_ENV !== "development") {
    //         if (window.location.origin.includes('-testserver')) {
    //             str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
    //         } else {
    //             str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
    //         }
    //     }
    //     return str
    // }

    created() {
        this.projectId = Number(this.$route.query.id)  //总项目列表跳转报名学员id
        this.getCustomerListById()  //报名学员
    }
    //
    // beforeUpload (file) {
    //     // md5加密
    //     this.signature = makeUploadSignature('crm', file.name)
    //     return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.readAsDataURL(file);
    //         reader.onload = () => {
    //             resolve(true)
    //         };
    //         reader.onerror = (error) => {
    //             reject(error)
    //         }
    //     })
    // }

    returnSignContract(row) {
        //跳转新建学生合同
        window.open(window.location.origin + '/financialCenter/contractAddAgent?customerName='+row.customerName
            +'&customerId='+row.customerId +'&customerType='+row.customerType +
            '&customerSourceType='+row.customerSourceType +
            '&customerSource='+''+ encodeURIComponent(row.customerSource)+'' +
            '&marketCooperationId='+row.marketCooperationId ,
            '_blank')
    }



    handlePreview(file) {
        this.previewPath = file.url
        this.previewName = file.name
        this.previewVisible = true
    }

    fileExtension(type: any) {
        if (type) {
            return type.substring(type.lastIndexOf('.') + 1)
        }
    }


    getRowKeys(row: any) {
        return row.id
    }

    AllService() {
        this.serviceDialog = true
    }

    handleSelectionChange(arr: any) {
        // 选中的数据
        this.financeOrderIdList = []
        const newList = arr.map(item => (item.id))
        this.financeOrderIdList = newList
    }

    selectHandle(row) {
        if (row.finishAt) {
            return false
        }
        return true // 满足条件一定记得返true, 不然全都会禁选
    }


    isshow(row) {
        if (row.parentPhone === undefined) {
            this.isshowParentPhone = false
        }
        if(row.phone === undefined){
            this.isshowPhone = false
        }
        if(row.email === undefined){
            this.isshowEmail = false
        }
        if(row.weChat === undefined){
            this.isshowWeChat = false
        }
        if(row.prevMarketCooperationName === undefined){
            this.isshowPrevMarketCooperationName = false
        }
        if(row.eduCode === undefined){
            this.isshowEduCode = false
        }
        return true;
    }
    // 服务完成
    handleServiceComplete(row) {
        // this.financeOrderIdList = [row.id]
        this.serviceCompleteId = row.id
        this.serviceDialog = true
        this.createdAt = null // 清空服务完成时间
    }
    // 上传附件确定事件
    async clickServiceDialogConfirmButton(){

        // if(this.fileList.length === 0) { this.$message.error('请上传服务完成材料'); return } // 2023-11-10 拿掉必填项校验

        if(!this.createdAt){
            this.$message.error('请选择服务完成时间'); return
        }
        this.serviceDialog = false
        const obj = {
            financeOrderIdList: this.serviceCompleteId ? [this.serviceCompleteId] : this.financeOrderIdList,
            url: this.fileList.length > 0 ? this.fileList[0].url : '',
            createdAt: moment(this.createdAt).format('YYYY-MM-DD')
        }

        const data = await setFinanceOrderFinishByFinanceOrderId(delNullProperty(obj))
        this.getCustomerListById()  //报名学员
        this.$message.success('服务完成')
        this.fileList = []
        this.createdAt = null
        this.serviceCompleteId = ''
        this.financeOrderIdList = [];
        (this.$refs.multipleTable as HTMLFormElement).clearSelection();
    }

    handleRemove(file, fileList) {
        this.fileList = fileList.map((item: File) => ({name: item.name, url: item.url}))
    }

    handleRemoveFile(file: File, fileList: File[]) {
        this.$message.success('删除文件')
        // this.fileList = fileList.map((item: File) => ({ name: item.name, url: item.url }))
    }
    // 查看附件
    handleCheckAttachment(url){
        const a: any = document.createElement('a')
        a.href = url //  URL对象
        a.click() // 模拟点击
    }

    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.fileList.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.fileList = this.fileList.filter(item => item.uid !== file.uid)
    }

    pageChange(page: number) {
        if (this.timer !== null) clearTimeout(this.timer)
        this.timer = setTimeout(() => {
            this.page = page
            this.getCustomerListById()
        }, 1000)
    }

    pageSizeChange(val: number) {
        this.pageSize = val
        this.getCustomerListById()
    }

    // 报名学员
    async getCustomerListById() {
        this.loading = true

        const obj = {
            gradeList: this.tableHeadFilter.gradeList,
            id: this.projectId,
            customerName: this.tableHeadFilter.customerName,
            prevMarketCooperationName: this.tableHeadFilter.prevMarketCooperationName,
            dissertationType: this.tableHeadFilter.dissertationType,
            limit: this.pageSize,
            page: this.page,
        }
        if(this.tableHeadFilter.gradeList.length == 0){
            delete obj.gradeList
        }
        if (this.tableHeadFilter.dissertationType == '') {
            delete obj.dissertationType
        }
        if (this.tableHeadFilter.prevMarketCooperationName == '') {
            delete obj.prevMarketCooperationName
        }
        if (this.tableHeadFilter.customerName == '') {
            delete obj.customerName
        }
        const data: any = await getCustomerListById(obj)

        this.tableData = data.personList


        this.total = data.allNum
        // this.tableRandom = Math.random()
        this.$nextTick(() => {
            if (this.$refs.multipleTable) {
                (this.$refs.multipleTable as HTMLFormElement).doLayout();
                (this.$refs.multipleTable as HTMLFormElement).bodyWrapper.scrollTop = 0;
            }
        });
        this.loading = false
        // this.isReadonly = false
    }

    // 导出
    async exportData(keys: string = '') {
        this.exportButtonDisabled = true
        getCustomerListByIdExportData(delNullProperty({
            gradeList: this.tableHeadFilter.gradeList,
            id: this.projectId,
            customerName: this.tableHeadFilter.customerName,
            prevMarketCooperationName: this.tableHeadFilter.prevMarketCooperationName,
            dissertationType: this.tableHeadFilter.dissertationType,
            keys,
        })).then(() => {
            this.exportButtonDisabled = false
            this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        }).catch(() => [
            this.exportButtonDisabled = false
        ])
    }

    // 跳转跟进记录页
    followRecord(row) {
        window.open(window.location.origin + this.$route.matched[0].path + '/allProjectStudentFollowRecord?id=' + this.projectId + '&customerId=' + row.customerId + '&customerType=' + row.customerType  , '_blank')
    }
}
